module.exports = __webpack_public_path__ + "img/favicon.82b9c7a5.png";